import {QrOrderComponent} from './qr-order/qr-order.component';

import {Routes, RouterModule} from '@angular/router';
import {AuthGuard} from './_guards';
import {KioskContainerComponent} from './otherRoles/kiosk/kiosk-container/kiosk-container.component';
import {TableSetupComponent} from './sidebar-menu/table/table-setup/table-setup.component';
import {HomeComponent} from './otherRoles/home/home.component';
import {HubLoginComponent} from './hub-login/hub-login.component';
const appRoutes: Routes = [
  {
    path: 'hub-login',
    component: HubLoginComponent
  },
  {
    path: 'order',
    component: KioskContainerComponent,
    loadChildren: () => import('./otherRoles/order/order.module').then(m => m.OrderModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then(m => m.LoginModule),
  },
  {
    // Lazy-loaded so the kiosk bootstrap on /login-code does not pull the
    // full SharedModule + Material + MDBBootstrap surface — the Pi 4 used
    // to OOM-thrash here before Angular finished mounting.
    path: 'login-code',
    loadChildren: () => import('./login/login-code/login-code.module').then(m => m.LoginCodeModule),
  },
  {
    path: 'youtube',
    loadChildren: () => import('./otherRoles/youtube-container/youtube-container.module').then(m => m.YoutubeContainerModule),
  },
  {
    path: 'tableSetup',
    component: TableSetupComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'serverOrder',
    loadChildren: () => import('./sidebar-menu/admin-dashboard/admin-dashboard.module').then(m => m.AdminDashboardModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cloverAuth',
    loadChildren: () => import('./auth-router/clover-auth-router.module').then(m => m.CloverAuthRouterModule),
  },
  {
    // Public signed-payment landing for the SMS invoice flow. URL
    // shape: /pay/<orderId>?exp=<unixSeconds>&sig=<hex>. Peer of
    // /cloverAuth/cloverAuth, NOT a child — no AuthGuard. The
    // GuestPaymentComponent verifies the HMAC server-side, seeds a
    // guest user into sessionStorage, then forwards to
    // /payment-kiosk/paymentScreen.
    //
    // Mounted as a `pay` parent (with `:orderId` matched inside the
    // module's child routes) so every `/pay/*` shape — `/pay/abc`,
    // `/pay/abc/`, `/pay/abc/foo`, even bare `/pay` — lands inside
    // GuestPaymentModule. The module's own `**` then catches any
    // unrecognised sub-path and shows a clear "link invalid" message.
    // Critically, this prevents `/pay/...` URLs from EVER falling
    // through to the app-level `**` redirect, which historically sent
    // paying customers to the merchant login screen when prod hadn't
    // redeployed the new SMS-payment route yet — the silent failure
    // that caused the original bug Shahzib reported on 2026-05-19.
    //
    // The old /cloverAuth?qr=...&orderId=... URL also keeps working
    // for 2 weeks so SMS links already in customers' phones don't
    // break.
    path: 'pay',
    loadChildren: () => import('./guest-payment/guest-payment.module').then(m => m.GuestPaymentModule),
  },
  {
    path: 'sidebar',
    loadChildren: () => import('./sidebar-menu/sidebar-menu.module').then(m => m.SidebarMenuModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'paymentUser',
    component: KioskContainerComponent,
    loadChildren: () => import('./otherRoles/paymentUser/payment-user/paymentUser.module').then(m => m.PaymenUserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'rewards',
    loadChildren: () => import('./otherRoles/rewardsUser/rewards-user.module').then(m => m.RewardsUserModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'orderUser',
    loadChildren: () => import('./otherRoles/orderUser/kitchen-display-system/kitchen-display-system.module').then(m => m.KitchenDisplaySystemModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'confirmation-display',
    loadChildren: () => import('./otherRoles/confirmationDisplay/confirmation-display.module').then(m => m.ConfirmationDisplayModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'cashier',
    loadChildren: () => import('./cashier-register/cashier-register.module').then(m => m.CashierRegisterModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payment-kiosk',
    component: KioskContainerComponent,
    loadChildren: () => import('./otherRoles/payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'payment',
    loadChildren: () => import('./otherRoles/payment/payment.module').then(m => m.PaymentModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'kiosk',
    component: KioskContainerComponent,
    loadChildren: () => import('./otherRoles/kiosk/kiosk-component/kiosk.module').then(m => m.KioskModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'QROrder',
    component: QrOrderComponent,
    canActivate: [AuthGuard]
  },
  {
    path: 'receipt',
    loadChildren: () => import('./receipt/receipt.module').then(m => m.ReceiptModule),
  },
  {
    // Public website ordering entry point. No AuthGuard — the component
    // calls a public API to mint a session, then navigates to /order.
    path: 'website/:orgIdent',
    loadChildren: () => import('./website-entry/website-entry.module').then(m => m.WebsiteEntryModule),
  },
  {
    path: '',
    component: HomeComponent,
    pathMatch: 'full',
  },


  // otherwise redirect to home
  {path: '**', redirectTo: 'cloverAuth/cloverAuth'}
  // cloverAuth/cloverAuth
];

export const routing = RouterModule.forRoot(appRoutes, { relativeLinkResolution: 'legacy' });
